import type { Camp } from '@orbomb/sim';
import {
  inCross,
  normalizeInput,
  previewCross,
  type InputVector,
  type MatchState,
  type SimConfig,
} from '@orbomb/sim';

function aim(x: number, y: number): InputVector {
  return normalizeInput({ x, y });
}

/** Flees a live cross, otherwise chases a golden ball. Reads state only. */
export function seekerInput(state: MatchState, config: SimConfig, camp: Camp): InputVector {
  const player = state.players[camp === 'ORANGE' ? 0 : 1];
  if (!player || player.status === 'STUNNED' || state.clock.phase === 'COUNTDOWN' || state.result) {
    return { x: 0, y: 0 };
  }

  for (const explosion of state.explosions) {
    if (state.tick >= explosion.lethalUntilTick) continue;
    if (inCross(explosion.cross, player.x, player.y)) {
      return aim(player.x - (explosion.cross.col + 0.5), player.y - (explosion.cross.row + 0.5));
    }
  }

  for (const golden of state.goldens) {
    if (golden.status !== 'ARMED') continue;
    const cross = previewCross(state, config, golden);
    if (inCross(cross, player.x, player.y)) {
      return aim(player.x - golden.x, player.y - golden.y);
    }
  }

  let nearestDist = Number.POSITIVE_INFINITY;
  let nearest: { x: number; y: number } | null = null;
  for (const golden of state.goldens) {
    if (golden.status !== 'NEUTRAL' && golden.status !== 'ARMED') continue;
    const d = (golden.x - player.x) ** 2 + (golden.y - player.y) ** 2;
    if (d < nearestDist) {
      nearestDist = d;
      nearest = golden;
    }
  }
  if (nearest) return aim(nearest.x - player.x, nearest.y - player.y);
  return { x: 0, y: 0 };
}
